import React from "react";
import classes from "./expandabletext.module.css";

type props = {
  text: string;
  maxLength?: number;
  sameColorExpanded?: boolean;
};

function WithExpandableText({text, sameColorExpanded, maxLength = 30}: props) {
  const [expanded, setExpanded] = React.useState(false);

  if (!text || text.length <= maxLength) {
    return <span>{text}</span>;
  }

  return (
    <span
      className={
        expanded ? (sameColorExpanded ? classes.expandableSameText : classes.expandableText) : classes.foldedText
      }
      onClick={() => setExpanded(!expanded)}
    >
      {expanded ? text : <span className={classes.ellipsis}>{text.substring(0, maxLength)}...</span>}
    </span>
  );
}

export default WithExpandableText;
